<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ACTUALIZAR ESTADO</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <div class="grey--text text--darken-3 px-4 pt-4">
            <v-radio-group v-model="estadoAsesor" column>
              <v-radio
                class="px-5 prueba"
                v-for="(item, i) in estadoUsuario"
                @click="updateEstado()"
                :key="i"
                :label="item.title"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
export default {
  name: "ModAddEstado",
  data: () => ({
    loading: false,
    dialog: true,
    estadoAsesor: "",
    datosUsuario: {},
  }),

  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(["logueado", "estadoUsuario"]),
  },
  async mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      this.datosUsuario = await db.collection("usuarios").doc(this.id).get();
      this.estadoAsesor = this.datosUsuario.data().disponibilidad
        ? this.datosUsuario.data().disponibilidad
        : "Fuera de su horario laboral";
      this.loading = false;
    },
    async updateEstado() {
      const swal = await this.$swal({
        title: "Actualizar estado",
        text: `¿Esta seguro de actualizar el estado al usuario?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Actualizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        try {
          db.collection("usuarios")
            .doc(this.id)
            .update({ disponibilidad: this.estadoAsesor })
            .then(() => {
              this.$store.dispatch("trazabilidadEstadoUsuarios", {
                descripcion: "Estado actualizado por el Coordinador",
                estado: this.estadoAsesor,
                uidcaso: "",
                cargo: this.datosUsuario.data().cargo,
                uidusuario: this.id,
                uidcreador: this.logueado.id,
              });
            });
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } catch (error) {
          this.handleError(error);
        }
      } else {
        this.estadoAsesor = this.datosUsuario.data().disponibilidad
          ? this.datosUsuario.data().disponibilidad
          : "Fuera de su horario laboral";
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
